import { render, staticRenderFns } from "./BasicDetails.vue?vue&type=template&id=6f3a2a7c&scoped=true&xmlns%3Afont-size=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./BasicDetails.vue?vue&type=script&lang=js"
export * from "./BasicDetails.vue?vue&type=script&lang=js"
import style0 from "./BasicDetails.vue?vue&type=style&index=0&id=6f3a2a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a2a7c",
  null
  
)

export default component.exports